import React from 'react';
import { Link } from 'react-router-dom';
import { XIcon, ArrowRightIcon } from 'lucide-react';
import { Exchange } from '../types';
interface CompareBarProps {
  exchanges: Exchange[];
  onRemove: (id: string) => void;
  onClear: () => void;
}
export function CompareBar({
  exchanges,
  onRemove,
  onClear
}: CompareBarProps) {
  if (exchanges.length === 0) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-blue-600 shadow-2xl z-50 animate-slide-up" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-31">
        <div className="flex items-center justify-between gap-4" data-id="element-32">
          <div className="flex items-center gap-3 flex-1 overflow-x-auto" data-id="element-33">
            <span className="font-semibold text-gray-900 whitespace-nowrap" data-id="element-34">
              Compare ({exchanges.length}/3):
            </span>
            <div className="flex gap-2" data-id="element-35">
              {exchanges.map(exchange => <div key={exchange.id} className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 whitespace-nowrap" data-id="element-36">
                  <img src={exchange.logo} alt={exchange.name} className="w-5 h-5" data-id="element-37" />
                  <span className="text-sm font-medium text-gray-900" data-id="element-38">
                    {exchange.name}
                  </span>
                  <button onClick={() => onRemove(exchange.id)} className="text-gray-500 hover:text-red-600 transition-colors" data-id="element-39">
                    <XIcon size={16} data-id="element-40" />
                  </button>
                </div>)}
            </div>
          </div>

          <div className="flex items-center gap-3" data-id="element-41">
            <button onClick={onClear} className="text-sm text-gray-600 hover:text-gray-900 font-medium whitespace-nowrap" data-id="element-42">
              Clear All
            </button>
            {exchanges.length >= 2 && <Link to={`/compare?ids=${exchanges.map(e => e.id).join(',')}`} className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap" data-id="element-43">
                Compare Now
                <ArrowRightIcon size={18} data-id="element-44" />
              </Link>}
          </div>
        </div>
      </div>
    </div>;
}